module.exports = __webpack_public_path__ + "static/media/bg-18.aa97c796.png";